module.exports = __webpack_public_path__ + "static/media/width.70e2b903.svg";